import { Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { EntityService, TableData } from '@dot-it/jml-lib'
import { AdditionalQualifier } from '../../../dto/models/table-state.model'
import { of } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'
import { SoftFilter } from '../../../dto/models/softfilter'
import { EntityReference } from '../../../dto'
import { EditComponent } from 'projects/jml-lib/src/lib/components/edit-components/edit-component'

@Component({
  selector: 'jml-lib-entity-reference-input',
  templateUrl: './entity-reference-input.component.html',
  styleUrls: ['./entity-reference-input.component.scss']
})
export class EntityReferenceInputComponent extends EditComponent {
  @Input() fieldName: string // field.field
  @Input() displayName: string // field.header
  @Input() referenceType: string // field.referenceType
  @Input() referenceFilter: string | undefined // field.referenceFilter
  @Input() referenceSoftFilter: string | undefined // field.referenceSoftFilter
  @Input() entityRef: EntityReference | undefined // There may be cases without Entity Context
  @Input() showDelete = false

  @Output() onDelete: EventEmitter<void> = new EventEmitter()

  entitySelectionTableData: TableData
  entitySelectionContext: { field: string; textModule: HTMLInputElement }
  displayEntitySelectionDialog = false

  entityService = inject(EntityService)

  openEntitySelectionDialog(input: HTMLInputElement) {
    this.entitySelectionContext = { field: this.fieldName, textModule: input }

    let additionalQualifier: AdditionalQualifier
    if (this.referenceFilter) {
      additionalQualifier = new AdditionalQualifier(this.referenceFilter).setEntityRef(this.entityRef)
    }
    of(this.referenceSoftFilter)
      .pipe(
        take(1),
        switchMap((filter) => {
          if (filter?.includes('${')) {
            return this.entityService.eval(filter, undefined, this.entityRef).pipe(map((x) => x.result))
          } else {
            return of(filter)
          }
        })
      )
      .subscribe((referenceSoftFilter) => {
        this.entitySelectionTableData = new TableData(this.referenceType)
          .isEntitySelectionDialog()
          .hideHeader()
          .hideAttachments()
          .setScrollable()
          .disableInlineEdit()
          .setScrollHeight(window.innerHeight - 350 + 'px')
          .setFilters(
            additionalQualifier,
            !!referenceSoftFilter ? new SoftFilter(this.entityRef, referenceSoftFilter) : undefined
          )
        this.displayEntitySelectionDialog = true
      })
  }

  entitySelected(entity: any) {
    console.log('entitySelected', entity)
    if (!!entity) {
      const entityReference = new EntityReference(this.referenceType, entity['id'], entity['_repr_'])
      this.control.setValue(entityReference)
      this.emitUpdate()
      this.displayEntitySelectionDialog = false
    } else {
      console.log('tried to select null-entity')
    }
  }

  onClickDelete() {
    this.control.setValue(null)
    this.onDelete.emit()
    this.emitUpdate()
  }
}
